import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { CheckCircle2, AlertTriangle, Database } from "lucide-react";

const LABEL = { softone: "SoftOne (έξοδα)", print1: "Print1 (παραστατικά)", manual: "Χειροκίνητα παραστατικά", payroll: "Μισθοδοσία + ΦΜΥ/ΕΦΚΑ",
  hotelizer: "Hotelizer / Έσοδα", hotelizer_sales: "Hotelizer (σύνοψη)", income_monthly: "Έσοδα μηνός (αρχείο)", events: "Εκδηλώσεις", receipts: "Αποδείξεις προσωπικού" };
const EXPECTED = ["softone", "payroll", "hotelizer"];
const M = ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μάι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"];

// Import-center status cards: last month with data per source, read from the single ledger (fact_monthly).
export function ImportStatusCards({ year = new Date().getFullYear() }) {
  const { data } = useQuery({ queryKey: ["facts-status", year], queryFn: async () => (await api.get(`/facts/sources-status?year=${year}`)).data });
  if (!data) return null;
  const keys = Array.from(new Set([...EXPECTED, ...Object.keys(data.sources)])).filter((k) => k !== "hotelizer_sales");
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="import-status-cards">
      {keys.map((k) => {
        const s = data.sources[k];
        const ok = s && !s.missing.length;
        return (
          <div key={k} data-testid={`import-status-${k}`} className={`rounded-2xl border p-4 bg-white ${ok ? "border-[#CFE0D2]" : "border-[#F1D9C9]"}`}>
            <div className="flex items-center gap-2">
              {ok ? <CheckCircle2 className="h-5 w-5 text-[#3F6B4C]" /> : <AlertTriangle className="h-5 w-5 text-[#C86235]" />}
              <span className="font-semibold text-[#45423C] text-sm">{LABEL[k] || k}</span>
              <Database className="h-3.5 w-3.5 ml-auto text-[#B9AE9A]" />
            </div>
            <p className="text-xs text-[#6F6A60] mt-2">
              {s ? <>Τελευταίος μήνας: <b>{M[s.last_month - 1]} {year}</b> · {s.months.length} μήνες</> : <>Καμία εισαγωγή το {year}</>}
            </p>
            {s && s.missing.length > 0 && <p className="text-xs text-[#C86235] mt-1">Λείπουν: {s.missing.map((m) => M[m - 1]).join(", ")}</p>}
          </div>
        );
      })}
    </div>
  );
}
